import { render, staticRenderFns } from "./TgpLayout.vue?vue&type=template&id=978c02e8"
import script from "./TgpLayout.vue?vue&type=script&lang=js"
export * from "./TgpLayout.vue?vue&type=script&lang=js"
import style0 from "./TgpLayout.vue?vue&type=style&index=0&id=978c02e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports